import dayjs from 'dayjs';

export const checkMatchDate = (firstDate, secondDate) => {
  return dayjs(firstDate).format('DD/MM/YYYY') === dayjs(secondDate).format('DD/MM/YYYY');
};
